import { useState } from "react";
import { IntroStyled } from "./about-me-style";

export const Intro = ({ introText }) => {
    const [showFullText, setShowFullText] = useState(false);

    const introTextLength = introText.split(" ").length;

    const handleClick = () => {
        setShowFullText(!showFullText);
    };
    return (
        <IntroStyled showfulltext={showFullText} >
            <div id="intro">
                <h2>Intro</h2>
                <p>
                    {
                        introTextLength < 50 || showFullText ?
                            introText :
                            `${introText.split(' ').slice(0, 50).join(' ')}...`
                    }
                    <span className='see-more' onClick={handleClick} >
                        {
                            introTextLength > 50 &&
                            (showFullText ? 'See less' : 'See more')
                        }
                    </span>
                </p>

            </div>
        </IntroStyled>
    )
}